
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 12.15A3.15 3.15 0 119 5.85 3.15 3.15 0 019 12.15zm0-5.014a1.864 1.864 0 100 3.728 1.864 1.864 0 000-3.728z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.997 14.955a10.032 10.032 0 01-8.57-4.867 2.118 2.118 0 010-2.176 9.91 9.91 0 018.569-4.867 10.05 10.05 0 018.574 4.866 2.117 2.117 0 010 2.178 10.037 10.037 0 01-8.573 4.866zm0-10.624a8.636 8.636 0 00-7.465 4.242.845.845 0 000 .856 8.74 8.74 0 007.465 4.24 8.631 8.631 0 007.472-4.24.846.846 0 000-.857A8.64 8.64 0 008.997 4.33z","fill":"currentColor"}})])
          )
        }
      }
    